var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rfirfa"},[_c('div',{staticClass:"rfirfa_container"},[_c('div',{staticClass:"rfirfa_one"},[_c('rfi',{on:{"showDetail":_vm.showDetail}})],1),_vm._v(" "),_c('div',{staticClass:"rfirfa_one"},[_c('rfa',{on:{"showDetail":_vm.showDetail}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92532396","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rfirfa/main.vue
// module id = null
// module chunks = 